import { Form } from 'vform'

const session = {
    state: () => ({
        form: new Form({
            service_id: null,
            room_id: null,
            resources: [],
            start_time: null,
            start_date: null,
            end_date: null,
            capacity: 0,
            number_of_weeks: null,
            days: [],
            durations_by_type: 0,
            duration_type: 'minute',
            generate_session_mode: 'single_session',
        })
    }),

    mutations: {
        //
    },

    getters: {
        //
    }
}

export default session;
